import type { JSX } from 'react';

export const EMPTY_VALUE = '—';

export const resolveFormattedValue = (value: number | undefined, formattedValue: string | JSX.Element) => {
  if (typeof formattedValue === 'string' || formattedValue?.props?.children?.[0] === undefined) {
    return formattedValue;
  }

  const [currentValue, ...rest] = formattedValue.props.children;
  return { ...formattedValue, props: { ...formattedValue.props, children: [value === undefined ? EMPTY_VALUE : currentValue, ...rest] } };
};
